/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Scroll_HintInputs */

const en_us2_wrapped_scroll_hint = /** @type {(inputs: Wrapped_Scroll_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scroll for more`)
};

const pt_br2_wrapped_scroll_hint = /** @type {(inputs: Wrapped_Scroll_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role para ver mais`)
};

const es_419_wrapped_scroll_hint = /** @type {(inputs: Wrapped_Scroll_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplázate para ver más`)
};

const pt_pt2_wrapped_scroll_hint = /** @type {(inputs: Wrapped_Scroll_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desliza para ver mais`)
};

const fr_fr2_wrapped_scroll_hint = /** @type {(inputs: Wrapped_Scroll_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fais défiler pour voir plus`)
};

const de_de2_wrapped_scroll_hint = /** @type {(inputs: Wrapped_Scroll_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrollen für mehr`)
};

const it_it2_wrapped_scroll_hint = /** @type {(inputs: Wrapped_Scroll_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scorri per vedere altro`)
};

/**
* | output |
* | --- |
* | "Scroll for more" |
*
* @param {Wrapped_Scroll_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_scroll_hint = /** @type {((inputs?: Wrapped_Scroll_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Scroll_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_scroll_hint(inputs)
	if (locale === "es-419") return es_419_wrapped_scroll_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_scroll_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_scroll_hint(inputs)
	if (locale === "de-DE") return de_de2_wrapped_scroll_hint(inputs)
	if (locale === "it-IT") return it_it2_wrapped_scroll_hint(inputs)
	return en_us2_wrapped_scroll_hint(inputs)
});
export { wrapped_scroll_hint as "wrapped.scroll_hint" }